import { twMerge } from "tailwind-merge"
const Heading5: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, children, ...props }) => {
  return (
    <h5
      className={twMerge("font-extrabold text-[1.25rem] md:text-[1.5rem] leading-[100%] md:leading-[100%]", className)}
      {...props}>
      {children}
    </h5>
  )
}

export default Heading5
